export default {
  GET_TABLE_LIST: '/manage/announcement/list',
  SAVE_DETAIL: '/manage/announcement/add',
  UPDATE_DETAIL: '/manage/announcement/update',
  GET_DETAIL: '/manage/announcement/detail',
  UPDATE_STATUS: '/manage/announcement/hidden',
  GET_ANNOUNCE: '/auth/announcement/detail'
}



// WEBPACK FOOTER //
// ./src/axios/api_urls/announcement.js